"use client";

import { useEffect, useRef } from "react";

type Props = {
  slot: string;
};

export default function AdSense({ slot }: Props) {
  const adRef = useRef<HTMLModElement | null>(null);
  const isProd = process.env.NODE_ENV === "production";
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!adRef.current) return;
    if (pushedRef.current) return;

    try {
      pushedRef.current = true;
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      pushedRef.current = false;
      console.warn("AdSense push error", e);
    }
  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={{
        display: "block",
        width: "100%",
        maxHeight: "100%",
        textAlign: "center",
      }}
      data-ad-client="ca-pub-6961894978461409"
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
      {...(!isProd ? { "data-adtest": "on" } : {})}
    />
  );
}
